// import { MobileState } from "@/Apps/Pages/MobileResponsiveToggle/types";
import {
  convertFromRem,
  convertToRem,
} from "@/Apps/Pages/MobileResponsiveToggle/style";
import * as Tools from "@/Apps/Pages/Properties";
import { NiceMenu } from "@/Apps/Pages/Properties/BuildingBlocks/Interactions/Helpers";
// import { ButtonSliderGroup } from "@/Apps/Pages/Properties/components/groups/ButtonSliderGroup/ButtonSliderGroup";
import { ButtonSliderGroup } from "@/Apps/Pages/Properties/BuildingBlocks/ButtonSliderGroup/ButtonSliderGroup";

import ListItem from "@/ui/_old/ListItem";
import { Minus, Plus } from "@phosphor-icons/react";
import { get } from "lodash";
// import React from "react";
// import { ListItem, NiceMenu } from "@launchos/components/ui";
// import * as Tools from "@launchos/modules/editor/Builder/Properties";
// import { MobileState } from "@launchos/modules/editor/Builder/MobileResponsiveToggle/types";

const BasicPropertiesTab = (props) => {
  const { getMobileState } = props;
  const { type } = getMobileState();

  const handleGapChange = (value, shouldDbUpdate = true, wait = 100) => {
    const currentGap = get(props.settings.properties, "gap", 0);
    const convertedGapValue = convertFromRem(currentGap, type);
    const gap = Number(convertedGapValue);
    const gapOffset = value === "UP" ? gap - 10 : gap + 10;
    const newGap = Number.isInteger(value) ? value : gapOffset;

    // convert the raw pixel value to rem before saving it the db
    const newValue = convertToRem(newGap, type);

    props.updateComponentStyle(
      props.settings.id,
      { gap: newValue },
      shouldDbUpdate,
      wait
    );

    if (props.onChange) props.onChange();
  };

  return (
    <>
      <Tools.Background {...props} label="Background" />
      <Tools.WidthHeight {...props} label="Size" />
      <Tools.Section label="Gap">
        <ButtonSliderGroup
          onChange={handleGapChange}
          text="Gap"
          button1={{ icon: <Minus />, value: "UP" }}
          button2={{ icon: <Plus />, value: "DOWN" }}
          minValue={0}
          maxValue={200}
          value={convertFromRem(get(props.settings.properties, "gap", 0), type)}
        />
      </Tools.Section>
      <Tools.Section label="Position" icon="import_export">
        <Tools.Margin {...props} />
      </Tools.Section>
      <Tools.Alignment
        {...props}
        label="Alignment"
        verticalAlign={false}
        marginAlign
      />
    </>
  );
};

const AdvancedPropertiesTab = (props) => {
  const { getMobileState } = props;
  const { type } = getMobileState();

  const setItemsPerRow = ({ updateComponentStyle, settings }, num) => {
    updateComponentStyle(settings.id, {
      maxColumnsPerRow: num,
    });
  };

  return (
    <>
      <Tools.Section label="Columns Per Row" icon="view_column" isExpanded>
        <div style={{ padding: 10 }}>
          <NiceMenu
            label={`Max items per row: ${get(
              props.settings.properties,
              `mobile[${props.getMobileState().type}].maxColumnsPerRow`,
              ""
            )}`}
          >
            <ListItem onClick={() => setItemsPerRow(props, 1)}>1</ListItem>
            <ListItem onClick={() => setItemsPerRow(props, 2)}>2</ListItem>
            <ListItem onClick={() => setItemsPerRow(props, 3)}>3</ListItem>
            <ListItem onClick={() => setItemsPerRow(props, 4)}>4</ListItem>
            <ListItem onClick={() => setItemsPerRow(props, 5)}>5</ListItem>
          </NiceMenu>
        </div>
      </Tools.Section>
      <Tools.BorderShadow {...props} label="Borders & Shadows" isExpanded />
    </>
  );
};

export const Properties = (props) => (
  <Tools.PropertiesWindow
    {...props}
    defaultTab="basic"
    tabs={[
      { id: "basic", title: "Row", component: BasicPropertiesTab },
      { id: "advanced", title: "Advanced", component: AdvancedPropertiesTab },
    ]}
  />
);

export default Properties;
